export default __webpack_public_path__ + "static/media/gc_logo_powby_horiz_white.2b878485.png";